// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-area';

export const Component = () => (
  <path d='M0 0h1v21h21v1H0V0Zm3 8 3.188 4 4.25-3 3.187 3L20 14v5H3V8Z' />
);

export const viewBox = '0 0 22 22';
